import api from '../config/api';

export const getActiveShippingCities = async () => {
  const response = await api.get('/shipping-cities/active');
  return response.data;
};

export const validatePromoCode = async (code, orderAmount) => {
  const response = await api.post('/promo-codes/validate', { code, orderAmount });
  return response.data;
};

export const checkFreeShipping = async (orderAmount, promoCode) => {
  const response = await api.get('/shipping-settings/check-free', {
    params: { orderAmount, promoCode }
  });
  return response.data;
};

// Public free-shipping threshold (EGP) for display copy. Returns null when the
// backend does not expose it (older API) or no min-order rule is active, so
// callers fall back to generic wording instead of a hardcoded amount.
export const getFreeShippingThreshold = async () => {
  try {
    const response = await api.get('/shipping-settings/free-threshold');
    const value = parseFloat(response.data?.threshold);
    return Number.isFinite(value) && value > 0 ? value : null;
  } catch {
    return null;
  }
};
